import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './theme.scss'
import './reset.scss'
import {
  Expand,
  Fold,
  UserFilled,
  ArrowDown,
  Close,
  CircleClose,
  ArrowLeft,
  ArrowRight,
  Edit,
  CirclePlus,
  Plus,
  Minus,
  DeleteFilled,
  Warning,
  ZoomIn,
  Check,
  Download,
  Delete,
  House,
  Setting,
  MoreFilled,
  WarningFilled
} from '@element-plus/icons-vue'

export const initElementPlusUI = (app) => {
  app.use(ElementPlus, { size: 'mini', zIndex: 3000 })
  app.component('Expand', Expand)
  app.component('Fold', Fold)
  app.component('UserFilled', UserFilled)
  app.component('ArrowDown', ArrowDown)
  app.component('Close', Close)
  app.component('CircleClose', CircleClose)
  app.component('ArrowLeft', ArrowLeft)
  app.component('ArrowRight', ArrowRight)
  app.component('Edit', Edit)
  app.component('CirclePlus', CirclePlus)
  app.component('Plus', Plus)
  app.component('Minus', Minus)
  app.component('DeleteFilled', DeleteFilled)
  app.component('ZoomIn', ZoomIn)
  app.component('Download', Download)
  app.component('Delete', Delete)
  app.component('House', House)
  app.component('Setting', Setting)
  app.component('Check', Check)
  app.component('Warning', Warning)
  app.component('MoreFilled', MoreFilled)
  app.component('WarningFilled', WarningFilled)
}
